const gatedContentWidgets = document.querySelectorAll<HTMLElement>(`.gated-content`);

function populateGatedContentDocumentFields(): void {
  if (gatedContentWidgets) {
    gatedContentWidgets.forEach(gatedContentWidget => {
      var documentTitleField = gatedContentWidget.querySelector<HTMLElement>('input[data-reference-name="data-gated-document-name"]');
      var documentLinkField = gatedContentWidget.querySelector<HTMLElement>('input[data-reference-name="data-gated-document-url"]');
      var documentTitle = gatedContentWidget.dataset['gatedDocumentName']
      var documentLink = gatedContentWidget.dataset['gatedDocumentUrl']
      if (documentTitleField && documentTitle) {
        documentTitleField.setAttribute('value', documentTitle);
      };
      if (documentLinkField && documentLink) {
        documentLinkField.setAttribute('value', documentLink);
      };

      checkForConfirmationText(gatedContentWidget);
      gatedContentObserver.observe(gatedContentWidget, {
        characterDataOldValue: true,
        subtree: true,
        childList: true,
        characterData: true
      });

    });
    
  }
}

let gatedContentObserver = new MutationObserver((e) => {
  var target = e[0].target;
  var parentElement = target.parentElement;
  var gatedContentWidget = parentElement.closest('.gated-content');
  if (gatedContentWidget) {
    checkForConfirmationText(gatedContentWidget);
  }
});

function checkForConfirmationText(gatedContentWidget): void {
  var modalTitle = gatedContentWidget.querySelector('.modal-title');
  var modalIntro = gatedContentWidget.querySelector('.modal-body > .intro');
  var modalConfirmation = gatedContentWidget.querySelector('.modal-body .formwidget-submit-text');
  
  if (modalConfirmation) {
    if (modalTitle) {
      modalTitle.classList.add('d-none');
    }
    if (modalIntro) {
      modalIntro.classList.add('d-none');
    }
  } else {
    if (modalTitle) {
      modalTitle.classList.remove('d-none');
    }
    if (modalIntro) {
      modalIntro.classList.remove('d-none');
    }
  }
}

// Run on page load
document.addEventListener('DOMContentLoaded', () => {
  populateGatedContentDocumentFields();
});
